import { Button, Text, Flex } from '@chakra-ui/react'
import SideNav from '@/components/SideNavbar'

export default function UnauthorizedPage() {
    return (
        <SideNav>
            <Flex
                minH="80vh"
                align="center"
                justify="center"
                flexDirection={'column'}
                bg={'gray.50'}
                p={{ base: 4, sm: 6, lg: 8 }}
            >
                <Text fontSize="2xl" m={4}>
                    You don&apos;t have permission to access this page
                </Text>
                <Button onClick={() => window.history.back()}>Go Back</Button>
            </Flex>
        </SideNav>
    )
}
